package com.yogaaicoach.pages.trainingprogram

import kotlinx.serialization.Serializable

// Mirrors composeApp's CreateTrainingProgramRequest/DayAndDuration exactly — same field names
// and wire format, since both clients hit the same backend endpoint.
@Serializable
data class CreateTrainingProgramRequest(
    val goals: Set<MainGoal>,
    val level: LevelKey,
    val ageGroup: AgeGroupKey,
    val daysInWeek: Int? = null,
    val durationInMinutes: Int? = null,
    val schedule: List<DayAndDuration>
)

@Serializable
data class DayAndDuration(val day: Weekday, val duration: Duration)
